/**
 * Turn `estimated-portfolio` `data` into a stable UI object (aligned with ProfileProvider mapping).
 */
export function normalizeEstimatedPortfolioData(raw = {}, slugHint = "") {
  const r = raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};

  const walletTypesNorm = r.wallet_types ?? r.walletTypes;

  const dollar =
    r.dollarPrice ??
    r.estimated_total_usdt ??
    r.estimatedTotalUsdt ??
    r.estimated_total ??
    r.total_usdt;

  const preferredRaw = r.estimated_total_preferred ?? r.estimatedTotalPreferred;

  const prefCurrencyRaw =
    r.currency_prefrence ?? r.currency_preference ?? r.preferred_currency;

  const wt =
    r.wallet_type ?? r.walletType ?? r.walletTypeSlug ?? (slugHint ? String(slugHint).trim() : "");

  return {
    ...r,
    ...(Array.isArray(walletTypesNorm) && walletTypesNorm.length ? { wallet_types: walletTypesNorm } : {}),
    wallet_type: wt,
    dollarPrice: dollar,
    estimated_total_preferred:
      preferredRaw !== undefined && preferredRaw !== null && preferredRaw !== "" ? preferredRaw : dollar,
    currency_prefrence: prefCurrencyRaw ?? r.Currency ?? "USD",
    currencyPrice:
      r.currencyPrice ??
      r.currency_price ??
      r.fiat_value ??
      r.estimated_fiat_value ??
      r.total_fiat_usd ??
      r.approximate_fiat_balance ??
      dollar,
  };
}
